export default {
  cssClasses: {
    hiddenCard: 'card-generic--hidden',
  },
  selectors: {
    card: '[data-comp-generic-card]',
    categoryGroups: '[data-comp-card-filtering-categories]',
    checkbox: '[data-comp-checkbox]',
    container: '[data-comp-card-filtering="enable"]',
  },
};
